/**
 * Representa un nodo individual en una lista doblemente enlazada.
 * @template T - El tipo del valor almacenado en el nodo.
 */
export class Node<T> {
  value: T
  next: Node<T> | null = null
  prev: Node<T> | null = null

  constructor(value: T) {
    this.value = value
  }
}